import {createSelector, createSelectorCreator, defaultMemoize} from 'reselect'

/**
 * Used to configure selector cache for search selectors with parameters
 * 1000 is an arbitrary number, picked to confidently contain multiple pages of hotels with offers (and potentially more offers loaded)
 */
const SELECTOR_MAX_CACHE_ENTRIES = 1000

/**
 * Creating a global cached selector results in memory leaks when working in the server.
 *
 * Memoization on the server brings almost no benefit, so we are falling back to default createSelector.
 */
export const memoizedCreateSelector =
  typeof window === 'undefined'
    ? createSelector
    : createSelectorCreator(defaultMemoize, {
        maxSize: SELECTOR_MAX_CACHE_ENTRIES
      })
